<script setup lang="ts">
import { ProductPage } from "~/pages/product";
</script>
<template>
  <ProductPage />
</template>
